import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

import Title from "../../styled-components/Title";

export default styled(Title)`
  width: 100%;
  padding: 0 16px;
  text-align: left;

  @media screen and (min-width: ${DESKTOP}px) {
    width: 900px;
    padding: 0;
  }
`;
